import React from "react";
import { mainNavBarItems } from "./components/Header/MainNavBarItems";
import { BasketView } from "./views/BasketView";
import { OrderDetailsView } from "./views/OrderDetailsView";
import { MyOrdersView } from "./views/MyOrdersView";
import { StatsView } from "./views/admin/statistics/StatsView";
import { RegisterView } from "./views/RegisterView";
import { RegisterSuccessView } from "./views/successViews/RegisterSuccessView";
import { MyAccountView } from "./views/MyAccountView";
import { AdminView } from "./views/admin/AdminView";
import { RightsView } from "./views/footer/RightsView";
import { TermsView } from "./views/footer/TermsView";
import { ImprintView } from "./views/footer/ImprintView";
import { DisclaimerView } from "./views/footer/DisclaimerView";
import { PrivacyNoticeView } from "./views/footer/PrivacyNoticeView";
import { TrademarksView } from "./views/footer/TrademarksView";
import { ManageSubscriptionsView } from "./views/admin/ManageSubscriptionsView";
import { MySubscriptionsView } from "./views/MySubscriptionsView";
import { MySubscriptionFilesView } from "./views/MySubscriptionFilesView";
import { ManageSubscriptionUsersView } from "./views/admin/ManageSubscriptionUsersView";
import { ManageSubscriptionContactsView } from "./views/admin/ManageSubscriptionContactsView";
import { SignInOrRegisterView } from "./views/SignInOrRegisterView";
import { ManageOrdersView } from "./views/admin/ManageOrdersView";
import { PersonalDataView } from "./views/myAccount/PersonalDataView";
import { DownloadCentreView } from "./views/myAccount/DownloadCentreView";
import { ChangePasswordView } from "./views/myAccount/ChangePasswordView";
import { ChangePasswordSuccessView } from "./views/successViews/ChangePasswordSuccessView";
import TableDemoView from "./components/UniversalTable/demo/TableDemoView";
import { ManageSpecificUserView } from "./views/admin/ManageSpecificUserView";
import { ManageUsersView } from "./views/admin/ManageUsersView";
import { ManageUserSubscriptionsView } from "./views/admin/ManageUserSubscriptionsView";
import { ManageUsersAddMultipleSubscriptionsView } from "./views/admin/ManageUsersAddMultipleSubscriptions";
import { MultipleSubscriptionsSuccessView } from "./views/successViews/MultipleSubscriptionsSuccessView";
import { ContactView } from "./views/ContactView";
import { SuccessView } from "./views/successViews/SuccessView";
import { KneipSuccessView } from "./views/successViews/KneipSuccessView";
import { SubscriptionRequestView } from "./views/SubscriptionRequestView";
import { SubscriptionRequestSuccessView } from "./views/successViews/SubscriptionRequestSuccessView";
import { InfoCenterView } from "./views/InfoCenterView";
import { EmptyOrderView } from "./views/admin/EmptyOrderView";
import { ManageQuotasView } from "./views/admin/ManageQuotasView";
import { QuotaOrdersView } from "./views/admin/QuotaOrdersView";
import { ProductOverview } from "./views/ProductOverview";
import { ProductDetailView } from "./views/ProductDetailView";
import { BasketSuccessView } from "./views/BasketSuccessView";
import { CsdrView } from "./views/CsdrView";
import { OrderOnBehalfView } from "./views/admin/OrderOnBehalfView";
import { InternalUserRegistrationView } from "./views/login/InternalUserRegistrationView";
import { PublicLinkDownloadView } from "./views/PublicLinkDownloadView";
import { Permission } from "../constants/PERMISSIONS";
import { LogoutTimerView } from "./components/LogoutTimer/LogoutTimerView";
import { LogoutView } from "./views/LogoutView";
import { SaveUserDetailsView } from "./views/SaveUserDetailsView";
import { ExternalLoginView } from "./views/login/ExternalLoginView";
import { SaveUserDetailsSuccessView } from "./views/successViews/SaveUserDetailsSuccessView";
import { GenerateApiTokenView } from "./views/myAccount/GenerateApiTokenView";
import { EmailVerificationView } from "./views/EmailVerificationView";
import { TasksView } from "./views/admin/TasksView";
import { A7ProductDetails } from "./views/a7/A7ProductDetails";
import { SendEmailToActiveUsersView } from "./views/admin/SendEmailToActiveUsersView";
import { ManageProductsView } from "./views/admin/ManageProductsView";
import { ManageSubscriptionRequestsView } from "./views/admin/ManageSubscriptionRequestsView";
import { ManageUseCasesTabsView } from "./views/admin/useCases/ManageUseCasesTabsView";
import { MyReportsTabsView } from "./views/myAccount/reports/MyReportsTabsView";
import { ManageReportsView } from "./views/admin/ManageReportsView";
import { ContractMenuView } from "./views/admin/contracts/ContractsMenuView";
import { ContractTypesView } from "./views/admin/contracts/ContractTypesView";
import { InformationProductsView } from "./views/admin/contracts/InformationProductsView";
import { BusinessPartnersView } from "./views/admin/contracts/BusinessPartnersView";
import { ContractsView } from "./views/admin/contracts/ContractsView";
import { RelationsView } from "./views/admin/contracts/RelationsView";
import { SalesRegistrationView } from "./views/admin/salesRegistration/SalesRegistrationView";
import { SalesRegistrationSuccessView } from "./views/successViews/SalesRegistrationSuccessView";
import { AcceptPrivacyNoticeView } from "./views/AcceptPrivacyNoticeView";
import { AcceptPrivacyNoticeSuccessView } from "./views/successViews/AcceptPrivacyNoticeSuccessView";
import { RegisterUserOnBehalfView} from "./views/admin/onBehalfRegistration/RegisterUserOnBehalfView";
import { RegisterUserOnBehalfSuccessView } from "./views/admin/onBehalfRegistration/RegisterUserOnBehalfSuccessView";
import { SampleDataView } from "./views/sampleData/SampleDataView";
import { GenerateMarketplaceTokenView } from "./views/admin/GenerateMarketplaceTokenView";

type IRoleType = "anonymous" | "user" | "admin";

interface IRouteBase {
    path: string;
    component: JSX.Element | ((props) => void);
    role: IRoleType;
}

interface IRouteUser extends IRouteBase {
    role: "user";
}

interface IRouteAnonymous extends IRouteBase {
    role: "anonymous";
}

export interface IRouteAdmin extends IRouteBase {
    scope?: Permission | Permission[];
    role: "admin";
}

export type IRoute = IRouteAnonymous | IRouteUser | IRouteAdmin;

export const routes: IRoute[] = [
    ...mainNavBarItems.map(menuItem => ({
        path: menuItem.path,
        component: menuItem.component,
        role: "anonymous" as IRoleType
    })),
    ///////////////////////////////
    // admin
    ///////////////////////////////
    // tasks disabled for now
    {
        path: "/admin/tasks",
        component: <TasksView />,
        role: "admin",
        scope: ["tasks.read", "tasks.write"]
    },
    {
        path: "/admin/stats",
        component: <StatsView />,
        role: "admin",
        scope: ["stats.read"]
    },
    {
        path: "/admin/order-on-behalf",
        component: <OrderOnBehalfView />,
        role: "admin",
        scope: "orders.write"
    },
    {
        path: "/admin/manage-orders",
        component: <ManageOrdersView />,
        role: "admin",
        scope: ["orders.read", "orders.write"]
    },
    {
        path: "/admin/manage-orders/create",
        component: <EmptyOrderView />,
        role: "admin",
        scope: "orders.write"
    },
    {
        path: "/admin/manage-orders/:orderId",
        component: <OrderDetailsView />,
        role: "admin",
        scope: ["orders.read", "orders.write"]
    },
    {
        path: "/admin/manage-subscriptions",
        component: <ManageSubscriptionsView />,
        role: "admin",
        scope: ["subscriptions.read", "subscriptions.write"]
    },
    {
        path: "/admin/manage-subscriptions/:subscriptionId",
        component: <ManageSubscriptionUsersView />,
        role: "admin",
        scope: ["subscriptions.users.read"]
    },
    {
        path: "/admin/manage-subscriptions/:subscriptionId/contacts",
        component: <ManageSubscriptionContactsView />,
        role: "admin",
        scope: ["subscriptions.write"]
    },
    {
        path: "/admin/manage-subscriptions/:subscriptionId/sendEmail",
        component: <SendEmailToActiveUsersView />,
        role: "admin",
        scope: ["subscriptions.write"]
    },
    {
        path: "/admin/manage-subscription-requests",
        component: <ManageSubscriptionRequestsView />,
        role: "admin",
        scope: ["subscriptions.read", "subscriptions.write"]
    },
    {
        path: "/admin",
        component: <AdminView />,
        role: "admin",
        scope: [
            "users.read",
            "users.write",
            "stats.read",
            "orders.read",
            "orders.write",
            "orders.status.write",
            "subscriptions.read",
            "subscriptions.write",
            "subscriptions.users.read",
            "subscriptions.users.write",
            "orders.quota.write",
            "orders.quota.read",
            "users.sales.register"
        ]
    },
    {
        path: "/admin/manage-users",
        component: <ManageUsersView />,
        role: "admin",
        scope: ["users.read", "users.write"]
    },
    {
        path: "/admin/manage-users/add-multiple-subscriptions",
        component: <ManageUsersAddMultipleSubscriptionsView />,
        role: "admin",
        scope: "users.write"
    },
    {
        path: "/admin/manage-users/add-multiple-subscriptions/success",
        component: <MultipleSubscriptionsSuccessView />,
        role: "admin",
        scope: "users.write"
    },
    {
        path: "/admin/manage-users/register-on-behalf",
        component: <RegisterUserOnBehalfView />,
        role: "admin",
        scope: "users.write"
    },
    {
        path: "/admin/register-on-behalf/success",
        component: <RegisterUserOnBehalfSuccessView />,
        role: "admin",
        scope: ["users.sales.register"]
    },
    {
        path: "/admin/manage-users/:userId",
        component: <ManageSpecificUserView />,
        role: "admin",
        scope: ["users.read", "users.write"]
    },
    {
        path: "/admin/manage-users/:userId/orders",
        component: <ManageOrdersView />,
        role: "admin",
        scope: ["orders.read", "orders.write"]
    },
    {
        path: "/admin/manage-users/:userId/subscriptions",
        component: <ManageUserSubscriptionsView />,
        role: "admin",
        scope: ["subscriptions.users.read", "subscriptions.users.write"]
    },
    {
        path: "/admin/manage-users/:userId/orders/:orderId",
        component: props => <OrderDetailsView {...props.match.params} />,
        role: "admin",
        scope: ["orders.read", "orders.write"]
    },
    {
        path: "/admin/quotas",
        component: <ManageQuotasView />,
        role: "admin",
        scope: ["orders.quota.read", "orders.quota.write"]
    },
    {
        path: "/admin/quotas/:quotaId/orders",
        component: <QuotaOrdersView />,
        role: "admin",
        scope: ["orders.quota.read", "orders.quota.write"]
    },
    {
        path: "/admin/manage-products",
        component: <ManageProductsView />,
        role: "admin",
        scope: ["products.read", "products.write"]
    },
    {
        path: "/admin/manage-use-cases",
        component: <ManageUseCasesTabsView />,
        role: "admin",
        scope: ["usecases.write", "usecases.write"]
    },
    {
        path: "/admin/manage-reports",
        component: <ManageReportsView />,
        role: "admin",
        scope: ["reports.read", "reports.write"]
    },
    {
        path: "/admin/contracts",
        component: <ContractMenuView />,
        role: "admin",
        scope: ["contracts.read", "contracts.write"]
    },
    {
        path: "/admin/contracts/types",
        component: <ContractTypesView />,
        role: "admin",
        scope: ["contracts.read", "contracts.write"]
    },    
    {
        path: "/admin/contracts/products",
        component: <InformationProductsView />,
        role: "admin",
        scope: ["contracts.read", "contracts.write"]
    },
    {
        path: "/admin/business-partners",
        component: <BusinessPartnersView />,
        role: "admin",
        scope: ["businessPartners.read", "businessPartners.write"]
    },
    {
        path: "/admin/contracts/contracts",
        component: <ContractsView />,
        role: "admin",
        scope: ["contracts.read", "contracts.write"]
    },
    {
        path: "/admin/contracts/products-subscriptions",
        component: <RelationsView />,
        role: "admin",
        scope: ["contracts.read", "contracts.write"]
    },
    {
        path: "/admin/sales-registration",
        component: <SalesRegistrationView />,
        role: "admin",
        scope: ["users.sales.register"]
    },
    {
        path: "/admin/sales-registration/success",
        component: <SalesRegistrationSuccessView />,
        role: "admin",
        scope: ["users.sales.register"]
    },
    {
        path: "/admin/marketplace-token",
        component: <GenerateMarketplaceTokenView />,
        role: "admin",
        scope: ["marketplaceToken.create"]
    },
    ///////////////////////////////
    // user
    ///////////////////////////////
    {
        path: "/my-account/personal-data/:redirect?",
        component: <PersonalDataView />,
        role: "user"
    },
    {
        path: "/my-account/my-orders",
        component: <MyOrdersView />,
        role: "user"
    },
    {
        path: "/my-account/my-orders/:orderId",
        component: props => <OrderDetailsView {...props.match.params} />,
        role: "user"
    },
    {
        path: "/my-account",
        /*labelId: "My Account",*/
        component: <MyAccountView />,
        role: "user"
    },
    {
        path: "/my-account/my-subscriptions",
        component: <MySubscriptionsView />,
        role: "user"
    },
    {
        path: "/my-account/my-subscriptions/:subscriptionId",
        component: <MySubscriptionFilesView />,
        role: "user"
    },
    {
        path: "/my-account/change-password",
        component: <ChangePasswordView />,
        role: "user"
    },
    {
        path: "/my-account/change-password/success",
        component: <ChangePasswordSuccessView />,
        role: "user"
    },
    {
        path: "/my-account/download-centre",
        component: <DownloadCentreView />,
        role: "user"
    },
    {
        path: "/my-account/api-token",
        component: <GenerateApiTokenView />,
        role: "user"
    },
    {
        path: "/my-account/my-reports",
        component: <MyReportsTabsView />,
        role: "user"
    },
    {
        path: "/accept-privacy-notice",
        component: <AcceptPrivacyNoticeView />,
        role: "anonymous"
    },
    {
        path: "/accept-privacy-notice/success",
        component: <AcceptPrivacyNoticeSuccessView />,
        role: "anonymous"
    },
    ///////////////////////////////
    // anonymous
    ///////////////////////////////
    {
        path: "/my-account/csdr",
        component: <CsdrView />,
        role: "anonymous"
    },
    {
        path: "/basket/:stepId",
        component: <BasketView />,
        role: "anonymous"
    },
    {
        path: "/basket-status/:orderId",
        component: <BasketSuccessView />,
        role: "anonymous"
    },
    {
        path: "/register",
        component: <RegisterView />,
        role: "anonymous"
    },
    {
        path: "/register/success",
        component: <RegisterSuccessView />,
        role: "anonymous"
    },
    {
        path: "/intellectual-property-rights-and-rights-of-use",
        component: <RightsView />,
        role: "anonymous"
    },
    {
        path: "/terms-and-conditions",
        component: <TermsView />,
        role: "anonymous"
    },
    {
        path: "/imprint",
        component: <ImprintView />,
        role: "anonymous"
    },
    {
        path: "/disclaimer",
        component: <DisclaimerView />,
        role: "anonymous"
    },
    {
        path: "/privacy-notice",
        component: <PrivacyNoticeView />,
        role: "anonymous"
    },
    {
        path: "/trademarks",
        component: <TrademarksView />,
        role: "anonymous"
    },
    {
        path: "/sign-in-or-register",
        component: <SignInOrRegisterView />,
        role: "anonymous"
    },
    {
        path: "/contact",
        component: <ContactView />,
        role: "anonymous"
    },
    {
        path: "/contact/success",
        component: <SuccessView headline="Contact us" />,
        role: "anonymous"
    },    
    {
        path: "/contact/success-kneip",
        component: <KneipSuccessView headline="Contacting Kneip" />,
        role: "anonymous"
    },
    {
        path: "/a7product/success",
        component: <SuccessView headline="A7 Analytics Platform" />,
        role: "anonymous"
    },
    {
        path: "/subscription-request",
        component: <SubscriptionRequestView />,
        role: "anonymous"
    },
    {
        path: "/subscription-request/success",
        component: <SubscriptionRequestSuccessView />,
        role: "anonymous"
    },
    {
        path: "/info-center",
        component: <InfoCenterView />,
        role: "anonymous"
    },
    {
        path: "/products",
        component: <ProductOverview />,
        role: "anonymous"
    },
    {
        path: "/product/details/:productIdentifier",
        component: <ProductDetailView />,
        role: "anonymous"
    },
    {
        path: "/internalUserRegistration",
        component: <InternalUserRegistrationView />,
        role: "anonymous"
    },
    {
        path: "/externalLogin",
        component: <ExternalLoginView />,
        role: "anonymous"
    },
    {
        path: "/logout",
        component: <LogoutView />,
        role: "anonymous"
    },
    {
        path: "/save-user-details",
        component: <SaveUserDetailsView />,
        role: "anonymous"
    },
    {
        path: "/save-user-details/success",
        component: <SaveUserDetailsSuccessView />,
        role: "anonymous"
    },
    {
        path: "/download/:publicLinkId",
        component: <PublicLinkDownloadView />,
        role: "anonymous"
    },
    // TODO: just for the table usage demo purpose, will be removed
    {
        path: "/tabledemo",
        component: <TableDemoView />,
        role: "anonymous"
    },
    {
        path: "/logout-timer",
        component: <LogoutTimerView />,
        role: "anonymous"
    },
    {
        path: "/verifyEmail/:emailVerificationCode",
        component: <EmailVerificationView />,
        role: "anonymous"
    },
    {
        path: "/a7product/details/:productIdentifier",
        component: <A7ProductDetails />,
        role: "anonymous"
    },
    {
        path: "/sample-data/details/:productIdentifier",
        component: <SampleDataView />,
        role: "anonymous"
    },
    {
        path: "/sample-data/success",
        component: <SuccessView headline="Analytics Sample Data" />,
        role: "anonymous"
    },
];
